import styled from "styled-components";

export const PremiumPubInfoWrapper = styled.div`
  padding: 0 16px 30px;
`;

export const PremiumPubInfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
`;

export const PremiumPubInfoTextBox = styled.div<{ isFold?: boolean }>`
  width: 100%;
  ${({ isFold }) => (isFold ? "max-height: 126px;" : "")}
  border-radius: 8px;
  padding: 16px;
  background: var(--Black-100, #f0f0f0);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  > .content {
    width: 100%;
    ${({ isFold }) => (isFold ? "max-height: 94px" : "height: 100%")};
    flex-grow: 1;
    color: var(--Black-500, #202020);
    font-size: 13px;
    font-weight: 400;
    line-height: 140%;
    transition: max-height 0.3s;
    overflow: hidden;
  }

  > img {
    width: 24px;
    height: 24px;
    transition: transform 0.5s;
    transform: ${({ isFold }) => (isFold ? "rotate(0)" : "rotate(180deg)")};
  }
`;

export const PremiumPubInfoFacilitiesWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  row-gap: 12px;
  justify-items: center;
  justify-content: center;
  margin-top: 12px;

  > .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;

    > img {
      width: 32px;
      height: 32px;
    }

    > span {
      font-family: Inter;
      font-weight: 400;
      font-size: 12px;
      color: var(--Black-400, #444444);
    }
  }
`;
